import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

export default function ActivityChartHelpIcon({
  message,
}: {
  message: string
}) {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <Typography variant="body1" className={classes.text}>
          {message}
        </Typography>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}
